<template>
    <div class="container mt-4">
        <gamification-points
            :color="color"
            :student="student"
            :studentPlans="studentPlans"
            :gamification-rules="gamificationRules"
        />
        <gamification-ranking
            v-if="gamificationRules.gamification_ranking"
            :color="color"
            :student="student"
            :studentPlans="studentPlans"
            :gamification-rules="gamificationRules"
        />
    </div>
</template>

<script>
import GamificationPoints from './GamificationPoints.vue';
import GamificationRanking from './GamificationRanking.vue';

export default {
    name: 'GamificationScore',

    components: {
        GamificationPoints,
        GamificationRanking,
    },

    props: {
        gamificationRules: Object,
        userRoles: Object,
        breadcrumbItems: Array,
        rules: {
            type: Array,
            default: () => ([])
        },
        color: {
            type: Object,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        studentPlans: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            
        };
    },

    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
    },

    methods: {
        
    },

    mounted() {
        
    }
};
</script>

<style scope>
.form-group {
  margin-bottom: 10px;
}

.input-container {
  max-width: 400px;
  width: 100%;
  margin-right: 20px;
}

.nch--custom-switch {
    margin-bottom: 20px;
}
</style>
